import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import KiosksFlag from '../views/KiosksFlag.vue'
import CreateJobsView from '../views/CreateJobsView'
import StatisticsManagementView from '../views/StatisticsManagementView'
import EnergyCardManagementView from '../views/EnergyCardManagementView'
import MainBoard from '../views/MainBoard.vue'
import UsersView from '../views/UsersView.vue'
import KioskManagementView from '../views/KioskManagementView'
import Login from '../views/Login'
import Jobs from '../views/Jobs'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [

  {
    path:'/debug', 
    name:'test', 
    component: Home,
    meta: {
      requiresAuth: true
  }
    
  },
  {
    path:'/login',
    name:'login', 
    component: Login,
 
  },
  {
    path: '/',
    component: MainBoard,
    name:'mainBoard',
    meta: {
      requiresAuth: true
  }
  },
  {
    path: '/flags',
    name: 'KiosksFlag',
    component: KiosksFlag,
    meta: {
      requiresAuth: true
  }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/createJob',
    name:'NameOfCreateJob',
    component: CreateJobsView,
    meta: {
      requiresAuth: true
  },
  },
 
  

  {
    path: '/users',
    name:'UsersManagement',
    component: UsersView,
    meta: {
      requiresAuth: true,
      mustBeAdmin:true
    }
  },
  {
    path: '/kiosks-management',
    name:'KioskManagement',
    component: KioskManagementView,
    meta: {
      requiresAuth: true,
      mustBeAdmin:true
    }
  }, 
  {
    path: '/statistics-management',
    name: 'StatisticsManagement',
    component: StatisticsManagementView,
    meta: {
      requiresAuth: true,
      mustBeAdmin: true
    }
  },
  {
    path: '/energy-card',
    name: 'EnergyCardManagement',
    component: EnergyCardManagementView,
    meta: {
      requiresAuth: true,
      mustBeAdmin: true
    }
  },
  {
    path: '/radar',
    name:'Radar',
    component: DashboardView,
    meta: {
      requiresAuth: true,
      mustBeAdmin:false
    }
  },
  {
    path: '/fleet-overview',
    name: 'FleetOverview',
    component: () => import('../views/FleetOverviewView.vue'),
    meta: {
      requiresAuth: true,
      mustBeAdmin: false
    }
  },
  {
    path: '/jobs',
    component: Jobs,
    meta: {
      requiresAuth: true
    }
}
]

const router = new VueRouter({
  routes
})

import { store } from "@/models/Store.js";
import DashboardView from "../views/DashboardView.vue";

router.beforeEach((to, from, next) =>{
  
  if(to.matched.some(record => record.meta.requiresAuth)) {

      if (localStorage.getItem('jwt') == null) {
        //console.log("jwt null")
        store.resetSessionInfos();
        next({name:'login'})

      } else {
       
        verifyToken().then((doc) => {
          //console.log(doc);
          if(doc.status===204){
            
            if(to.matched.some(record => record.meta.mustBeAdmin) && store.state.isCurrentUserAdmin || !to.matched.some(record => record.meta.mustBeAdmin) ){
             
              next();
            }else{
             
              //console.log("PAS LE DROIT")
              next({name:'mainBoard'})
            }
            
          }else{
            //console.log("status in verifyToken==/", doc.status)
              next({name:'login'})
          }
        })
        .catch((error) => {
              
              console.log(error)
              next({name:'login'})
            
        });

      }
  }else{
    //console.log("else")
    next();
  }
})

function verifyToken(){
 return axios({
    method: 'post', 
    url: process.env.VUE_APP_API_EXT_URL.split('API_EXT')[0] + 'auth/API_EXT/verifyToken',
    headers: { 
    Authorization: 'Bearer '+localStorage.getItem('jwt')
  }});
}

export default router
